@if (widgetAttributes.widgetProperties?.['dataType'] === CarouselDataType.NONE) {
<finxone-web-frontend-layout-driven-carousel
  [carouselConfig]="carouselConfig"
  [isWorkflow]="isWorkflow"
  [carouselSlideConfigs]="carouselSlideConfigs"
  [emblaOptions]="emblaOptions"
  [carouselStyle]="carouselStyle"
  [carouselSlidesContainerStyle]="carouselSlidesContainerStyle"
></finxone-web-frontend-layout-driven-carousel>
}
